import Vue from 'vue'
import VueRouter, { isNavigationFailure } from 'vue-router'
import i18n from '@/i18n'
import { getToken, isTokenExpired, isAuthenticated, clearSession, markExpiredNotice } from '@/services/session'
import { MODULE_POLICIES } from '@/services/negeriScope'
import Paparanutama from '@/views/paparanutama/paparanutama.vue'
import Maintemplate from '@/layout/maintemplate/maintemplate.vue'
import Login from '@/views/Login/Login'
import Publicheader from '@/layout/publictemplate/publictemplate'
//import Frontline from '@/views/Frontline/Frontline'
import Daftar from '@/views/Daftar/Daftar'
import Lupatakalaluan from '@/views/Lupatakalaluan/Lupatakalaluan'
import Tetapkanpenyeliaprosesanoperasi from '@/views/tetapkanpenyeliaprosesanoperasi/tetapkanpenyeliaprosesanoperasi'
import Pusingan from '@/views/pusingan/pusingan_new'
import Kawalanpenerbitan from '@/views/Kawalanpenerbitan/kawalanpenerbitan'
import Pamerdatahiestiadaakses from '@/views/Kawalanpenerbitan/pamerdatahiestiadaakses'
import Hiesidresponden from '@/views/Hiesidresponden/hiesidresponden'
import KadarresponOld from '@/views/Kadarrespon/kadarrespon-old'
import Kadarrespon from '@/views/Kadarrespon/kadarrespon'
import BulananPurata from '@/views/pendapatanpurata/bulananPurata'
import BulananPenengah from '@/views/pendapatanpurata/bulananPenengah'
import KaumXstrataJR2 from '@/views/KaumXstrata/kaumXstrataJR2'
import DaerahXstrataJR2 from '@/views/KaumXstrata/daerahXstrataJR2'
import PerbelanjaanPurata from '@/views/perbelanjaanpurata/perbelanjaanPurata'
import PerbelanjaanKaumStrata from '@/views/perbelanjaanpurata/perbelanjaanKaumStrata'
import PerbelanjaanDaerahStrata from '@/views/perbelanjaanpurata/perbelanjaanDaerahStrata'
import PerbelanjaanKomposisi from '@/views/perbelanjaanpurata/perbelanjaanKomposisi'
import JenisMilikanRumah from '@/views/KemudahanAsas/JenisMilikanRumah'
import BekalanAir from '@/views/KemudahanAsas/BekalanAir'
import BekalanElektrik from '@/views/KemudahanAsas/BekalanElektrik'
import KutipanSampah from '@/views/KemudahanAsas/KutipanSampah'
import pendapatanpurata from '@/views/pendapatanpurata/pendapatanpurata'
import penengah from '@/views/penengah/penengah'
import kaumxstrata from '@/views/KaumXstrata/kaumxstrata'
import DaerahXstrata from '@/views/DaerahXstrata/daerahxstrata'
import julatHarga from '@/views/julatHarga/julatHarga'
import julatHargaMinMax from '@/views/julatHarga/julatHargaMinMax'
import pivot from '@/views/pivot/pivot'
import validasi from '@/views/Validasi/validasi'
import Modulvalidasi from '@/views/Modulvalidasi/modulvalidasi'
import ModulvalidasiRujukan from '@/views/Modulvalidasi/rujukan'


//import testpage from '@/views/Testpage/Testpage'
//import testpage1 from '@/views/Testpage/Testpage1'
//import tablefilter from '@/views/tablefilter/tablefilter'
//import form from '@/views/form/form'
import Penggunasistem from '@/views/penggunasistem/penggunasistem'

import ConnectionStatus from '@/views/db-status/ConnectionStatus'
import MigrasiData from '@/views/Migrasidata/MigrasiData'
import AuditLog from '@/views/auditlog/AuditLog'


import LampiranManager from '@/views/Lampiran/LampiranManager'
import ConfigManager from '@/views/Config/ConfigManager'
import NegeriDaerahManager from '@/views/NegeriDaerah/NegeriDaerahManager'
/////////////BATCH//////////////////
import batch from '@/views/Daftar/batch'

///////////HID///////////////////
import HID from '@/views/Daftar/HID'

/////////////ringkasanIR////////////////
import ringkasanMaklumatIR from '@/views/paparanutama/ringkasanMaklumatIsiRumah'

///////////BP///////////////////
import BP from '@/views/Daftar/BP'

///////////koditem///////////////////
import koditem3 from '@/views/Daftar/koditem3'
import koditem4a from '@/views/Daftar/koditem4a'
import koditem4b from '@/views/Daftar/koditem4b'
import koditem4c from '@/views/Daftar/koditem4c'

///////HK1//////////////////////////////
import hk1 from '@/views/HIS/hk1'
import hk2 from '@/views/HIS/hk2'
import hk3 from '@/views/HIS/hk3'
import hk4 from '@/views/HIS/hk4'
import hk5 from '@/views/HIS/hk5'
import hk6 from '@/views/HIS/hk6'
import hk7 from '@/views/HIS/hk7'
import hk8 from '@/views/HIS/hk8'
import foodwaste from '@/views/HIS/foodwaste'

///////JR2//////////////////////////////
import JR2 from '@/views/JR/JR2'
import JRC from '@/views/JR/JRC'
import JRB from '@/views/JR/JRB'

import JRE1 from '@/views/JR/JRE1'
import JRE2 from '@/views/JR/JRE2'
import JRF3 from '@/views/JR/JRF3'
import JRG from '@/views/JR/JRG'
import JRH from '@/views/JR/JRH'

import PERBELANJAAN from '@/views/JR/PERBELANJAAN'
import JR2Imbangan from '@/views/JR/JR2Imbangan'
import JRBpindahan from '@/views/JR/JRBpindahan'
import IMBANGAN from '@/views/JR/IMBANGAN'
import JRB1off from '@/views/JR/JRB1off'
import JRCPSD from '@/views/JR/JRCPSD'
import JRD from '@/views/JR/JRD'
import ringkasanpendapatanAIR from '@/views/JR/ringkasanpendapatanAIR'


//////////////////blk//////////////////
import BLK3PreCode from '@/views/HES/BLK3PreCode' //first page hes
import blk3 from '@/views/HES/blk3'
import Blok4a from '@/views/HES/Blok4a'
import Blok4b from '@/views/HES/Blok4b'
import Blok4c from '@/views/HES/Blok4c'
import blk7 from '@/views/HES/blk7'
import Blok7Imbangan from '@/views/HES/Blok7Imbangan' 
import PengesahanImbangan from '@/views/HES/PengesahanImbangan' 
import Heshid from '@/views/HES/heshid'
///////////////////////summary/////////////////
import summaryJRB from '@/views/summary/summaryJRB'

import wajaran from '@/views/wajaran/wajaran'
import DataCollapseHes from '@/views/DataCollapseHes/DataCollapseHes'






Vue.use(VueRouter)

// vue-router >= 3.1 rejects the promise returned by push()/replace() when a navigation
// is redundant (NavigationDuplicated — "Avoided redundant navigation to current location")
// or gets redirected/aborted by a beforeEach guard. This app calls $router.push ~200 times
// without a .catch(), so a benign redundant navigation — e.g. logging in and landing on
// paparanutama when the guard would send you there anyway — surfaces as an uncaught runtime
// error overlay. Swallow only genuine navigation *failures* here, once and globally, and let
// real errors keep propagating. isNavigationFailure() matches every error flagged _isRouter.
const guardNavigation = (method) => {
  const original = VueRouter.prototype[method]
  VueRouter.prototype[method] = function (location, onResolve, onReject) {
    // Preserve the callback-style signature: vue-router doesn't return a promise then.
    if (onResolve || onReject) {
      return original.call(this, location, onResolve, onReject)
    }
    return original.call(this, location).catch((err) => {
      if (isNavigationFailure(err)) return err
      return Promise.reject(err)
    })
  }
}
guardNavigation('push')
guardNavigation('replace')

const routes = [
  // {
  //   path: '/testpage',
  //   name: 'testpage',
  //   component: testpage,
  // },
  {
    path: '/',
    redirect: `/${i18n.locale}/`,
  },
  {
    path: '/:lang',
    component: Publicheader,
    children: [
      // {
      //   path: "Frontline",
      //   name: "Frontline",
      //   component: Frontline
      // },
      {
        path: "daftar",
        name: "Daftar",
        component: Daftar
      },
      {
        path: `/`,  
        name: "Logmasuk",
        component: Login
      },
      {
        path: "lupatakalaluan",
        name: "Lupatakalaluan",
        component: Lupatakalaluan
      },
      {
        path: 'dashboard',
        beforeEnter() {
          window.open(
            'https://app.powerbi.com/view?r=eyJrIjoiNWRiNjMyODgtMGY2OS00OTFiLTliNGEtYzY3MmU0M2IxZDZkIiwidCI6IjM3M2U5MGQyLWQ5YTMtNDNiNS04MzJlLWM4ZTk4NDdhNzlmOCIsImMiOjEwfQ%3D%3D',
            '_blank'
          );
        }
      },
      // {
      //   path: '/testpage1',
      //   name: 'testpage1',
      //   component: testpage1
      // }
    ]
  },
  {
    path: '/:lang',
    component: Maintemplate,
    children: [
      {
        path: 'db-status',
        name: 'ConnectionStatus',
        component: ConnectionStatus,
        meta: { secure: true }
      },
      {
        path: 'migrasi-data',
        name: 'MigrasiData',
        component: MigrasiData,
        meta: { secure: true }
      },
      {
        path: 'audit-log',
        name: 'AuditLog',
        component: AuditLog,
        meta: { secure: true }
      },
      {
        path: 'paparanutama',
        name: "Paparanutama",
        component: Paparanutama,
        meta: { secure: true }
      },
      {
        path: 'pusingan',
        name: "Pusingan",
        component: Pusingan,
        meta: { secure: true }
      },
      {
        path: 'tetapkanpenyeliaprosesanoperasi/:url?',
        name: "Tetapkanpenyeliaprosesanoperasi",
        component: Tetapkanpenyeliaprosesanoperasi,
        meta: { secure: true }
      },
      {
        path: 'penggunasistem',
        name: "Penggunasistem",
        component: Penggunasistem,
        meta: { secure: true }
      },
      {
        path: 'ringkasanMaklumatIR',
        name: "ringkasanMaklumatIR",
        component: ringkasanMaklumatIR,
        meta: { secure: true }
      },
      {
        path: 'batch',
        name: "batch",
        component: batch,
        meta: { secure: true }
      },
      {
        path: 'HID',
        name: "HID",
        component: HID,
        meta: { secure: true }
      },

      {
        path: 'BP',
        name: "BP",
        component: BP,
        meta: { secure: true }
      },

      {
        path: 'koditem3',
        name: "koditem3",
        component: koditem3,
        meta: { secure: true }
      },

      {
        path: 'koditem4a',
        name: "koditem4a",
        component: koditem4a,
        meta: { secure: true }
      },

      {
        path: 'koditem4b',
        name: "koditem4b",
        component: koditem4b,
        meta: { secure: true }
      },

      {
        path: 'koditem4c',
        name: "koditem4c",
        component: koditem4c,
        meta: { secure: true }
      },

      {
        path: 'JR2',
        name: "JR2",
        component: JR2,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'JRC',
        name: "JRC",
        component: JRC,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'JRB',
        name: "JRB",
        component: JRB,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'hk1',
        name: "hk1",
        component: hk1,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'hk2',
        name: "hk2",
        component: hk2,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'hk3',
        name: "hk3",
        component: hk3,
        // props: true,
        meta: { secure: true }
      },
     {
       path: 'hk4',
       name: "hk4",
       component: hk4,
       // props: true,
       meta: { secure: true }
     },
      {
        path: 'hk5',
        name: "hk5",
        component: hk5,
        //props: true,
        meta: { secure: true }
      },
      {
        path: 'hk6',
        name: "hk6",
        component: hk6,
        //props: true,
        meta: { secure: true }
      },
    {
      path: 'hk7',
      name: "hk7",
      component: hk7,
      // props: true,
      meta: { secure: true }
    },
    {
      path: 'hk8',
      name: "hk8",
      component: hk8,
      // props: true,
      meta: { secure: true }
    },

    {
      path: 'foodwaste',
      name: "foodwaste",
      component: foodwaste,
      // props: true,
      meta: { secure: true }
    },

    {
      path: 'JRBpindahan',
      name: "JRBpindahan",
      component: JRBpindahan,
      // props: true,
      meta: { secure: true }
    },
    {
      path: 'IMBANGAN',
      name: "IMBANGAN",
      component: IMBANGAN,
      // props: true,
      meta: { secure: true }
    },
 	  {
        path: 'JRB1off',
        name: "JRB1off",
        component: JRB1off,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'JRCPSD',
        name: "JRCPSD",
        component: JRCPSD,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'JRD',
        name: "JRD",
        component: JRD,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'ringkasanpendapatanAIR',
        name: "ringkasanpendapatanAIR",
        component: ringkasanpendapatanAIR,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'BLK3PreCode/:hid?',
        name: "BLK3PreCode",
        component: BLK3PreCode,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'blk3/:hid?',
        name: "Blk3",
        component: blk3,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'Blok4a/:hid?',
        name: "Blok4a",
        component: Blok4a,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'Blok4b/:hid?',
        name: "Blok4b",
        component: Blok4b,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'Blok4c/:hid?',
        name: "Blok4c",
        component: Blok4c,
        // props: true,
        meta: { secure: true }
      },     
      {
        path: 'blk7/:hid?',
        name: "blk7",
        component: blk7,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'Blok7Imbangan/:hid?',
        name: "Blok7Imbangan",
        component: Blok7Imbangan,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'PengesahanImbangan/:hid?',
        name: "PengesahanImbangan",
        component: PengesahanImbangan,
        // props: true,
        meta: { secure: true }
      },
	    {
        path: 'summaryJRB',
        name: "summaryJRB",
        component: summaryJRB,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'JRE1',
        name: "JRE1",
        component: JRE1,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'JRE2',
        name: "JRE2",
        component: JRE2,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'JRF3',
        name: "JRF3",
        component: JRF3,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'JRG',
        name: "JRG",
        component: JRG,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'JRH',
        name: "JRH",
        component: JRH,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'PERBELANJAAN',
        name: "PERBELANJAAN",
        component: PERBELANJAAN,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'JR2Imbangan',
        name: "JR2Imbangan",
        component: JR2Imbangan,
        // props: true,
        meta: { secure: true }
      },
      {
        // "Pamer Data HIES" — this URL now renders the publication-control page.
        path: 'pamerdatahies',
        name: "Pamerdatahies",
        component: Kawalanpenerbitan,
        // props: true,
        meta: { secure: true }
      },
      {
        // Blocked-role landing for Pamer Data HIES — a SEPARATE component, so a
        // disallowed role never mounts the real page (no client flag to tamper).
        path: 'pamerdatahies-tiada-akses',
        name: "Pamerdatahiestiadaakses",
        component: Pamerdatahiestiadaakses,
        meta: { secure: true }
      },
      {
        path: 'modulvalidasi',
        name: "Modulvalidasi",
        component: Modulvalidasi,
        meta: { secure: true }
      },
      {
        path: 'modulvalidasi/rujukan',
        name: "ModulvalidasiRujukan",
        component: ModulvalidasiRujukan,
        meta: { secure: true }
      },
      {
        path: 'heshid',
        name: "Heshid",
        component: Heshid,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'hiesidresponden',
        name: "Hiesidresponden",
        component: Hiesidresponden,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'kadarrespon-old',
        name: "KadarresponOld",
        component: KadarresponOld,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'kadarrespon',
        name: "Kadarrespon",
        component: Kadarrespon,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'pendapatanpurata',
        name: "BulananPurata",
        component: BulananPurata,
        meta: { secure: true }
      },
      {
        path: 'pendapatanpenengah',
        name: "BulananPenengah",
        component: BulananPenengah,
        meta: { secure: true }
      },
      {
        path: 'pendapatankaumstrata',
        name: "KaumXstrataJR2",
        component: KaumXstrataJR2,
        meta: { secure: true }
      },
      {
        path: 'pendapatandaerahstrata',
        name: "DaerahXstrataJR2",
        component: DaerahXstrataJR2,
        meta: { secure: true }
      },
      {
        path: 'perbelanjaanpurata',
        name: "PerbelanjaanPurata",
        component: PerbelanjaanPurata,
        meta: { secure: true }
      },
      {
        path: 'perbelanjaankaumstrata',
        name: "PerbelanjaanKaumStrata",
        component: PerbelanjaanKaumStrata,
        meta: { secure: true }
      },
      {
        path: 'perbelanjaandaerahstrata',
        name: "PerbelanjaanDaerahStrata",
        component: PerbelanjaanDaerahStrata,
        meta: { secure: true }
      },
      {
        path: 'perbelanjaankomposisi',
        name: "PerbelanjaanKomposisi",
        component: PerbelanjaanKomposisi,
        meta: { secure: true }
      },
      {
        path: 'jenismilikanrumah',
        name: "JenisMilikanRumah",
        component: JenisMilikanRumah,
        meta: { secure: true }
      },
      {
        path: 'bekalanair',
        name: "BekalanAir",
        component: BekalanAir,
        meta: { secure: true }
      },
      {
        path: 'bekalanelektrik',
        name: "BekalanElektrik",
        component: BekalanElektrik,
        meta: { secure: true }
      },
      {
        path: 'kutipansampah',
        name: "KutipanSampah",
        component: KutipanSampah,
        meta: { secure: true }
      },
      {
        // Halaman lama, tiada pautan menu. Dinamakan semula supaya tidak
        // berlanggar dengan laluan 'pendapatanpurata' (Jadual Awalan) di atas.
        path: 'pendapatanpurata-old',
        name: "pendapatanpurataOld",
        component: pendapatanpurata,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'penengah',
        name: "penengah",
        component: penengah,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'kaumxstrata',
        name: "kaumxstrata",
        component: kaumxstrata,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'daerahxstrata',
        name: "DaerahXstrata",
        component: DaerahXstrata,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'julatharga',
        name: "julatHarga",
        component: julatHarga,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'julatHargaMinMax',
        name: "julatHargaMinMax",
        component: julatHargaMinMax,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'validasi',
        name: "validasi",
        component: validasi,
        props: true,
        meta: { secure: true }
      },
      {
        path: 'wajaran',
        name: "wajaran",
        component: wajaran,
        meta: { secure: true }
      },
      {
        path: 'datacollapsehes',
        name: "DataCollapseHes",
        component: DataCollapseHes,
        meta: { secure: true }
      },
      {
        path: 'pivot',
        name: "pivot",
        component: pivot,
        meta: { secure: true }
      },
      {
        path: 'lampiran-manager',
        name: 'LampiranManager',
        component: LampiranManager,
        meta: { secure: true }
      },
      {
        path: 'config',
        name: 'ConfigManager',
        component: ConfigManager,
        meta: { secure: true }
      },
      {
        path: 'negeri-daerah',
        name: 'NegeriDaerahManager',
        component: NegeriDaerahManager,
        meta: { secure: true }
      }
      
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// Route path → module policy key. Direct navigation to these pages is blocked for
// roles not on the module allow-list (mirrors the backend guard + the hidden menu).
const MODULE_BY_PATH = {
  // Jadual Awalan
  kadarrespon: 'jadualAwalan',
  pendapatanpurata: 'jadualAwalan', pendapatanpenengah: 'jadualAwalan',
  pendapatankaumstrata: 'jadualAwalan', pendapatandaerahstrata: 'jadualAwalan',
  perbelanjaanpurata: 'jadualAwalan', perbelanjaankaumstrata: 'jadualAwalan',
  perbelanjaandaerahstrata: 'jadualAwalan', perbelanjaankomposisi: 'jadualAwalan',
  jenismilikanrumah: 'jadualAwalan', bekalanair: 'jadualAwalan',
  bekalanelektrik: 'jadualAwalan', kutipansampah: 'jadualAwalan',
  // Julat Harga
  julatharga: 'julatHarga', julatHargaMinMax: 'julatHarga',
  // Audit Log
  'audit-log': 'auditLog',
  // Migrasi Data — SUPERADMIN only. Without this entry the route is reachable by
  // typing the URL: the `secure` meta only proves a valid session, not a role.
  'migrasi-data': 'migrasiData',
  // Status Sambungan + Konfigurasi — SUPERADMIN only, same reason.
  'db-status': 'dbStatus',
  config: 'konfigurasi',
  // Pengurusan Negeri & Daerah — SUPERADMIN sahaja, selari dengan
  // requireSuperAdmin di backend (/negeriDaerah). Ia menulis ke jadual rujukan
  // global, bukan membaca sahaja.
  'negeri-daerah': 'pengurusanNegeriDaerah',
  // Modul Pengurusan Pengguna — SUPERADMIN only. Note the Tetapkan PP/PO *page* is
  // gated, not the /pppo API: the Pppoinput component behind it is also
  // embedded in Daftar Batch and Daftar HID, which FE/PP/PO still use.
  penggunasistem: 'pengurusanPengguna',
  'tetapkanpenyeliaprosesanoperasi/:url?': 'pengurusanPengguna',
}

// Pamer Data HIES role gate — mirrors ANALISIS_ROLES in the backend
// (lib/analisis_penerbitan/analisisRoles.js). Others get the no-access page.
const PAMER_DATA_ROLES = ['ADMIN', 'SUPERADMIN', 'BPM', 'BPHPP']
function pamerDataRoleAllowed() {
  try {
    const u = JSON.parse(window.localStorage.getItem('user') || '{}')
    return PAMER_DATA_ROLES.includes(u.role)
  } catch (e) {
    return false
  }
}

function roleAllowedForRoute(to) {
  const moduleKey = to.matched.map(r => MODULE_BY_PATH[r.path]).find(Boolean)
  if (!moduleKey) return true // route not module-gated
  const policy = MODULE_POLICIES[moduleKey]
  let role
  try { role = (JSON.parse(window.localStorage.getItem('user')) || {}).role } catch (e) { role = undefined }
  return !!policy && policy.allowed.includes(role)
}

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)

  // If a token exists but has already expired, drop it so the guard treats the
  // user as logged out (and flag it so the login page shows a toast).
  if (getToken() && isTokenExpired()) {
    clearSession()
    markExpiredNotice()
  }

  const authed = isAuthenticated()

  if (to.matched.some(record => record.meta.secure)) {
    // Secure route: require a valid, unexpired session.
    if (!authed) {
      next({
        path: `/${i18n.locale}/`
      })
    } else if (to.name === 'Pamerdatahies' && !pamerDataRoleAllowed()) {
      // Pamer Data HIES: only ADMIN/BPM/BPHPP. Others get the dedicated
      // no-access page (a separate component — the real page never mounts).
      next({
        path: `/${i18n.locale}/pamerdatahies-tiada-akses`
      })
    } else if (!roleAllowedForRoute(to)) {
      // Logged in but role has no access to this module → send to the landing page.
      next({
        path: `/${i18n.locale}/paparanutama`
      })
    } else {
      next()
    }
  } else {
    // Public route: if already logged in, send to the role's landing page.
    if (authed) {
      const datapengguna = JSON.parse(window.localStorage.getItem('user'))
      if (datapengguna && datapengguna.role === 'RESPONDENT') {
        next({
          path: `/${i18n.locale}/ringkasanMaklumatIR`
        })
      } else {
        next({
          path: `/${i18n.locale}/paparanutama`
        })
      }
    } else {
      next()
    }
  }
})

export default router
